import React, { useState, useEffect } from 'react';
import api from '../api';

export default function AuswertungPage() {
  const [tab, setTab] = useState('flags');
  const [geldfresser, setGeldfresser] = useState([]);
  const [flags, setFlags] = useState(null);
  const [monate, setMonate] = useState(3);

  useEffect(() => { laden(); }, [monate]);

  async function laden() {
    const [g, f] = await Promise.all([
      api.get('/auswertung/geldfresser', { params: { monate } }),
      api.get('/auswertung/flags')
    ]);
    setGeldfresser(g.data);
    setFlags(f.data);
  }

  const tabs = [
    { id: 'flags', label: '🚨 Meine Flags' },
    { id: 'geldfresser', label: '💸 Top Ausgaben' },
    { id: 'abos', label: '🔄 Abos' },
  ];

  return (
    <div>
      <h1 style={{ margin: '0 0 16px', fontSize: '20px', color: '#1e293b' }}>🔍 Analyse</h1>

      <div style={{ display: 'flex', gap: '6px', marginBottom: '16px', overflowX: 'auto' }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ padding: '9px 14px', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '12px', whiteSpace: 'nowrap',
              background: tab === t.id ? '#6366f1' : '#f1f5f9', color: tab === t.id ? 'white' : '#64748b' }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* FLAGS TAB */}
      {tab === 'flags' && flags && (
        <div>
          {/* Zusammenfassung */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px', marginBottom: '16px' }}>
            {[
              ['🔥', 'Geldfresser', flags.gesamtGeldfresser, '#fef3c7', '#d97706'],
              ['🗑️', 'Überflüssig', flags.gesamtUeberfluessig, '#f3e8ff', '#7c3aed'],
              ['✂️', 'Kündigen', flags.gesamtKuendigen, '#fee2e2', '#dc2626'],
            ].map(([icon, label, betrag, bg, color]) => (
              <div key={label} style={{ background: bg, borderRadius: '12px', padding: '12px', textAlign: 'center', border: '1px solid ' + color }}>
                <div style={{ fontSize: '20px' }}>{icon}</div>
                <div style={{ fontSize: '10px', color, fontWeight: '600', marginTop: '2px' }}>{label}</div>
                <div style={{ fontSize: '15px', fontWeight: '700', color }}>{betrag?.toFixed(0)} €</div>
              </div>
            ))}
          </div>

          {/* Kündigen Liste */}
          {flags.kuendigen.length > 0 && (
            <div style={{ background: 'white', borderRadius: '14px', padding: '16px', marginBottom: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderTop: '3px solid #ef4444' }}>
              <h3 style={{ margin: '0 0 12px', color: '#dc2626', fontSize: '15px' }}>✂️ Zu kündigen</h3>
              {flags.kuendigen.map((k, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f1f5f9' }}>
                  <div>
                    <div style={{ fontWeight: '600', color: '#1e293b', fontSize: '13px' }}>{k.empfaenger}</div>
                    <div style={{ fontSize: '11px', color: '#94a3b8' }}>{k.kategorie} · {k.anzahl}× · zuletzt {k.letzter}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontWeight: '700', color: '#ef4444' }}>{k.gesamt.toFixed(2)} €</div>
                    <div style={{ fontSize: '11px', color: '#94a3b8' }}>⌀ {k.durchschnitt.toFixed(2)} €</div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Überflüssig Liste */}
          {flags.ueberfluessig.length > 0 && (
            <div style={{ background: 'white', borderRadius: '14px', padding: '16px', marginBottom: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderTop: '3px solid #8b5cf6' }}>
              <h3 style={{ margin: '0 0 12px', color: '#7c3aed', fontSize: '15px' }}>🗑️ Überflüssige Ausgaben</h3>
              {flags.ueberfluessig.map((u, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f1f5f9' }}>
                  <div>
                    <div style={{ fontWeight: '600', color: '#1e293b', fontSize: '13px' }}>{u.empfaenger}</div>
                    <div style={{ fontSize: '11px', color: '#94a3b8' }}>{u.kategorie} · {u.anzahl}×</div>
                  </div>
                  <div style={{ fontWeight: '700', color: '#8b5cf6' }}>{u.gesamt.toFixed(2)} €</div>
                </div>
              ))}
            </div>
          )}

          {/* Geldfresser Liste */}
          {flags.geldfresser.length > 0 && (
            <div style={{ background: 'white', borderRadius: '14px', padding: '16px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderTop: '3px solid #f59e0b' }}>
              <h3 style={{ margin: '0 0 12px', color: '#d97706', fontSize: '15px' }}>🔥 Geldfresser</h3>
              {flags.geldfresser.map((g, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f1f5f9' }}>
                  <div>
                    <div style={{ fontWeight: '600', color: '#1e293b', fontSize: '13px' }}>{g.empfaenger}</div>
                    <div style={{ fontSize: '11px', color: '#94a3b8' }}>{g.kategorie} · {g.anzahl}×
                      {g.muss_kuendigen ? ' · ✂️ Kündigen' : ''}
                      {g.ist_ueberfluessig ? ' · 🗑️ Überflüssig' : ''}
                    </div>
                  </div>
                  <div style={{ fontWeight: '700', color: '#f59e0b' }}>{g.gesamt.toFixed(2)} €</div>
                </div>
              ))}
            </div>
          )}

          {flags.geldfresser.length === 0 && flags.kuendigen.length === 0 && flags.ueberfluessig.length === 0 && (
            <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>
              <div style={{ fontSize: '40px', marginBottom: '12px' }}>📋</div>
              <p>Noch keine Flags gesetzt. Öffne Buchungen und markiere Geldfresser, überflüssige Ausgaben oder zu kündigende Verträge.</p>
            </div>
          )}
        </div>
      )}

      {/* GELDFRESSER TAB */}
      {tab === 'geldfresser' && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
            <span style={{ color: '#64748b', fontSize: '13px' }}>Zeitraum:</span>
            {[1,3,6,12].map(m => (
              <button key={m} onClick={() => setMonate(m)}
                style={{ padding: '6px 12px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '600',
                  background: monate === m ? '#6366f1' : '#f1f5f9', color: monate === m ? 'white' : '#64748b' }}>
                {m}M
              </button>
            ))}
          </div>
          {geldfresser.map((g, i) => (
            <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '14px', marginBottom: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: '600', color: '#1e293b', fontSize: '13px' }}>{g.empfaenger}</div>
                  <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>{g.kategorie} · {g.anzahl}× in {monate} Mon.</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontWeight: '700', color: '#ef4444', fontSize: '15px' }}>{g.gesamt.toFixed(2)} €</div>
                  <div style={{ fontSize: '11px', color: '#94a3b8' }}>⌀ {g.durchschnitt.toFixed(2)} €</div>
                </div>
              </div>
              <div style={{ marginTop: '8px', background: '#f1f5f9', borderRadius: '6px', height: '3px' }}>
                <div style={{ background: '#ef4444', borderRadius: '6px', height: '3px', width: Math.min(100, (g.gesamt / geldfresser[0]?.gesamt * 100)) + '%' }} />
              </div>
            </div>
          ))}
        </>
      )}

      {/* ABOS TAB */}
      {tab === 'abos' && flags && (
        <div>
          <div style={{ background: 'linear-gradient(135deg,#6366f1,#4f46e5)', borderRadius: '14px', padding: '16px', marginBottom: '16px', color: 'white', textAlign: 'center' }}>
            <div style={{ fontSize: '13px', opacity: 0.8 }}>Erkannte Fixkosten/Monat</div>
            <div style={{ fontSize: '28px', fontWeight: '700' }}>
              {flags.kuendigen.reduce((s, k) => s + k.durchschnitt, 0).toFixed(2)} €
            </div>
            <div style={{ fontSize: '12px', opacity: 0.7 }}>davon {flags.kuendigen.length} zu kündigen</div>
          </div>
          <p style={{ color: '#64748b', textAlign: 'center', fontSize: '13px' }}>
            Markiere Buchungen in "Buchungen" als ✂️ Kündigen um sie hier zu sehen.
          </p>
        </div>
      )}
    </div>
  );
}
